import moment from 'moment';
import { MESSAGE } from '@/models/Message';

export class Utils {

  public formatDate(
    strDate: string,
    outputFormat: string,
    inputFormat: string = 'YYYYMMDD',
  ): string {
    return moment(strDate, inputFormat).format(outputFormat);
  }

  public getFullDate(strDate: string, format: string): string {
    const date = moment(strDate, format);
    const year = date.format('YYYY');
    let dateOutput = '';
    let strY;
    if (format.indexOf('Y') > -1) {
      let jaYear;
      if (date.isBefore('19890108')) {
        // showa
        jaYear = Number(year) - 1925;
        strY = '昭和';
      } else {
        // heisei
        jaYear = Number(year) - 1988;
        strY = '平成';
      }
      dateOutput += strY + jaYear + '年';
    }
    if (format.indexOf('M') > -1) {
      dateOutput += date.format('M月');
    }
    if (format.indexOf('D') > -1) {
      dateOutput += date.format('D日');
    }

    return dateOutput;
  }

  public getHeiseiDate(strDate: string, format: string): string {
    if (strDate === '') {
      return '';
    }
    const date = moment(strDate, format);
    const year = date.format('YYYY');
    const heiseiYear = Number(year) - 1988;

    let dateOutput = 'H' + heiseiYear;
    if (format.length > 4) {
      const outputformat = format
        .replace('YYYY', '')
        .replace('MM', '/MM')
        .replace('DD', '/DD');
      dateOutput += date.format(outputformat);
    }

    return dateOutput;
  }

  public getNow(format: string): string {
    return moment().format(format);
  }

  public setSelect(element: HTMLInputElement) {
    setTimeout(() => {
      element.select();
    }, 10);
  }

  public focusNext(index: number, id?: string) {
    let nextEl: any;
    if (id) {
      nextEl = document.getElementById(id);
    } else if (index != null) {
      nextEl = document.querySelector(`[index='${index + 1}'`);
    }
    if (nextEl) {
      nextEl.focus();
    }
  }

  public padNumber(input: string, n: number): string {
    let s = input;
    while (s.length < n) {
      s = '0' + s;
    }
    return s;
  }

  public getNumberThousandSeparate(input: number): string {
    return input.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
  }

  public getUTF8Length(str: string, maxbyte: number) {
    if (str === '' || str == null) {
      return { count: 0, strCount: 0 };
    }
    let ch = null;
    let count = 0;
    let countTxt = 0;
    for (let i = 0; i < str.length; i++) {
      ch = str.charCodeAt(i);

      if (
        (ch >= 0x0 && ch < 0x81) ||
        ch === 0xf8f0 ||
        (ch >= 0xff61 && ch < 0xffa0) ||
        (ch >= 0xf8f1 && ch < 0xf8f4)
      ) {
        count += 1;
      } else {
        count += 2;
      }

      if (count <= maxbyte) {
        countTxt++;
      }
    }

    return { count, strCount: countTxt };
  }

  public removeLeadingZero(str: string) {
    return str.replace(/^0+/g, '');
  }

  public toASCII(chars: string) {
    let ascii = '';
    for (let i = 0, l = chars.length; i < l; i++) {
      let c = chars[i].charCodeAt(0);
      if (c >= 0xff00 && c <= 0xffef) {
        c = 0xff & (c + 0x20);
      }
      ascii += String.fromCharCode(c);
    }

    return ascii;
  }

  public getDurationMonth(startDate: string, endDate: string) {
    if (startDate && endDate) {
      const format = 'YYYYMMDD';
      const start = moment(startDate, format);
      const end = moment(endDate, format);
      const duration = moment.duration(start.diff(end));
      return Math.ceil(duration.asMonths());
    }
    return 0;
  }

  public getWSData(frame: any) {
    return JSON.parse(frame.body);
  }

  public removeNonEng(str: string) {
    return str.replace(/[^[A-Za-z\d]/g, '');
  }

  public getHttpErrorMessage(error: {
    status: number;
    rsltComment: string;
  }) {
    if (error.status < 500 && error.rsltComment) {
      return error.rsltComment;
    } else {
      return MESSAGE.SystemError;
    }
  }

  convertToJAHalfWidth(str: string) {
    let characters: string[] = str.split("");
    let halfWidthString = "";
    characters.forEach(character => {
      halfWidthString += this.mapToHankaku(character);
    });
    return halfWidthString;
  }

  mapToHankaku(character: string) {
    let zenHanMap: any = this.getZenkakuToHankakuMap();
    if (typeof zenHanMap[character] === "undefined") {
      return character;
    } else {
      return zenHanMap[character];
    }
  }

  getZenkakuToHankakuMap() {
    let zenHanMap = {
      ァ: "ｧ",
      ア: "ｱ",
      ィ: "ｨ",
      イ: "ｲ",
      ゥ: "ｩ",
      ウ: "ｳ",
      ェ: "ｪ",
      エ: "ｴ",
      ォ: "ｫ",
      オ: "ｵ",
      カ: "ｶ",
      ガ: "ｶﾞ",
      キ: "ｷ",
      ギ: "ｷﾞ",
      ク: "ｸ",
      グ: "ｸﾞ",
      ケ: "ｹ",
      ゲ: "ｹﾞ",
      コ: "ｺ",
      ゴ: "ｺﾞ",
      サ: "ｻ",
      ザ: "ｻﾞ",
      シ: "ｼ",
      ジ: "ｼﾞ",
      ス: "ｽ",
      ズ: "ｽﾞ",
      セ: "ｾ",
      ゼ: "ｾﾞ",
      ソ: "ｿ",
      ゾ: "ｿﾞ",
      タ: "ﾀ",
      ダ: "ﾀﾞ",
      チ: "ﾁ",
      ヂ: "ﾁﾞ",
      ッ: "ｯ",
      ツ: "ﾂ",
      ヅ: "ﾂﾞ",
      テ: "ﾃ",
      デ: "ﾃﾞ",
      ト: "ﾄ",
      ド: "ﾄﾞ",
      ナ: "ﾅ",
      ニ: "ﾆ",
      ヌ: "ﾇ",
      ネ: "ﾈ",
      ノ: "ﾉ",
      ハ: "ﾊ",
      バ: "ﾊﾞ",
      パ: "ﾊﾟ",
      ヒ: "ﾋ",
      ビ: "ﾋﾞ",
      ピ: "ﾋﾟ",
      フ: "ﾌ",
      ブ: "ﾌﾞ",
      プ: "ﾌﾟ",
      ヘ: "ﾍ",
      ベ: "ﾍﾞ",
      ペ: "ﾍﾟ",
      ホ: "ﾎ",
      ボ: "ﾎﾞ",
      ポ: "ﾎﾟ",
      マ: "ﾏ",
      ミ: "ﾐ",
      ム: "ﾑ",
      メ: "ﾒ",
      モ: "ﾓ",
      ャ: "ｬ",
      ヤ: "ﾔ",
      ュ: "ｭ",
      ユ: "ﾕ",
      ョ: "ｮ",
      ヨ: "ﾖ",
      ラ: "ﾗ",
      リ: "ﾘ",
      ル: "ﾙ",
      レ: "ﾚ",
      ロ: "ﾛ",
      ヮ: "",
      ワ: "ﾜ",
      ヲ: "ｦ",
      ン: "ﾝ",
      ヴ: "ｳﾞ",
      "・": "･",
      ー: "ｰ"
    };
    return zenHanMap;
  }

  deepCopy(obj: any) {
    return JSON.parse(JSON.stringify(obj));
  }

  filterSelectBoxMethod(val: string, key: string, items: any) {
    if (val) {
      return items.filter((e: any) => {
        if (e[key]) {
          return e[key].startsWith(val);
        } else {
          return e.startsWith(val);
        }
      });
    } else {
      return this.deepCopy(items);
    }
  }

  capitalize(txt: string) {
    return txt[0].toUpperCase() + txt.slice(1);
  }
  
  getFeeIdBase(feeList: any) {
    if (feeList.length > 0) {
      const fee = feeList.find((e: any) => e.isBase === 1);
      if (fee) {
        return fee.sknInspectSeibiFeeId;
      }
    }
    return null;
  }
}
